export default {
  downloadReceipt: 'Download / Print',

  // States
  receiptNotFound: 'Receipt Not Found',
  receiptNotFoundDescription:
    'The requested payment receipt could not be found. Please contact support if you believe this is an error.',
  goToHome: 'Go to Home',
} as const
